import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import JwtStore from './JwtStore';
import api from '../utils/api';
import checkStatus from '../utils/checkStatus';
import dispatchHttpError from '../utils/dispatchHttpError';

export default {
  fetch() {
    return fetch(api('languages'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => {
        Dispatcher.dispatch({
          actionType: ActionTypes.LANGUAGE_STORE_FETCH_COMPLETED,
          languages: response.data
        });
      })
      .catch(dispatchHttpError);
  }
}
